"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the full error details
    console.error("Error details:", {
      message: error.message,
      digest: error.digest,
      stack: error.stack,
      cause: error.cause,
    });
  }, [error]);

  // Show more details in development or if specific error messages exist
  const isDev = process.env.NODE_ENV === "development";
  const showDetails = isDev || error.message.includes("API request failed");

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="max-w-2xl text-center">
        <h2 className="mb-4 text-2xl font-bold text-gray-900">
          Something went wrong!
        </h2>

        {showDetails ? (
          <div className="mb-4 rounded-lg bg-red-50 p-4 text-left">
            <p className="mb-2 font-mono text-sm text-red-800">
              {error.message}
            </p>
            {error.stack && isDev && (
              <pre className="mt-2 overflow-x-auto text-xs text-red-600">
                {error.stack}
              </pre>
            )}
          </div>
        ) : (
          <p className="mb-2 text-gray-600">
            An unexpected error occurred. Please try again or contact support if
            the problem persists.
          </p>
        )}

        {error.digest && (
          <p className="mb-4 text-sm text-gray-500">Error ID: {error.digest}</p>
        )}

        <div className="flex gap-4 justify-center">
          <button
            onClick={reset}
            className="rounded-md bg-navy px-6 py-3 font-medium text-white hover:bg-navy/90"
          >
            Try again
          </button>
          <a
            href="/"
            className="rounded-md border border-navy px-6 py-3 font-medium text-navy hover:bg-navy/10"
          >
            Go home
          </a>
        </div>
      </div>
    </div>
  );
}
